/**
 * Labstep
 *
 * @desc ShowEdit component for Density
 */

import { fieldDensity } from 'labstep-web/components/PubChemMetadata/Form/fields';
import { PubChemMetadataFormShowEditGeneric } from 'labstep-web/components/PubChemMetadata/Form/ShowEdit/Generic';
import type React from 'react';
import type { IPubChemMetadataFormShowEditDensityProps } from './types';

export const PubChemMetadataFormShowEditDensity: React.FC<
  IPubChemMetadataFormShowEditDensityProps
> = ({ parent, pubChemMetadata }) => (
  <PubChemMetadataFormShowEditGeneric
    pubChemMetadata={pubChemMetadata}
    parent={parent}
    field={fieldDensity}
  />
);
